import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { name: 'AI Consulting', path: '/ai-consulting' },
      { name: 'AI Creation', path: '/ai-creation' },
      { name: 'Media & Brand', path: '/media-brand' },
    ],
    sectors: [
      { name: 'Sport', path: '/sectors#sport' },
      { name: 'City', path: '/sectors#city' },
      { name: 'Music', path: '/sectors#music' },
      { name: 'Entertainment', path: '/sectors#entertainment' },
    ],
    company: [
      { name: 'Work', path: '/work' },
      { name: 'Team', path: '/team' },
      { name: 'Contact', path: '/contact' },
    ],
  };

  return (
    <footer className="bg-elate-black border-t border-white/10" data-testid="footer">
      <div className="container-custom section-padding">
        {/* CTA Section */}
        <div className="mb-20">
          <h2 className="text-headline text-white mb-6">
            Ready to <span className="text-elate-yellow">Elevate</span>?
          </h2>
          <p className="text-lg text-gray-400 max-w-xl mb-8">
            Let's build something extraordinary together. Get in touch and let's discuss how we can transform your brand with AI-powered solutions.
          </p>
          <Link
            to="/contact"
            className="btn-primary inline-flex items-center gap-2"
            data-testid="footer-cta"
          >
            Start a Project
            <ArrowUpRight size={20} />
          </Link>
        </div>

        {/* Links Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 mb-20">
          {/* Logo & Description */}
          <div className="col-span-2 md:col-span-1">
            <img
              src="/images/logo.png"
              alt="Elate Global"
              className="h-12 w-auto mb-6"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              AI-first consultancy and brand strategy studio. Building brands and media that perform.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold uppercase tracking-wider text-sm mb-6">
              Services
            </h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-elate-yellow transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Sectors */}
          <div>
            <h4 className="text-white font-semibold uppercase tracking-wider text-sm mb-6">
              Sectors
            </h4>
            <ul className="space-y-3">
              {footerLinks.sectors.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-elate-yellow transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold uppercase tracking-wider text-sm mb-6">
              Company
            </h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-elate-yellow transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-white/10">
          <p className="text-gray-500 text-sm mb-4 md:mb-0">
            © {currentYear} Elate Global Ltd. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a
              href="https://x.com/elateglobal"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-elate-yellow transition-colors text-sm uppercase tracking-wider"
            >
              X
            </a>
            <a
              href="https://instagram.com/elateglobal"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-elate-yellow transition-colors text-sm uppercase tracking-wider"
            >
              Instagram
            </a>
            <Link
              to="/privacy-policy"
              className="text-gray-500 hover:text-elate-yellow transition-colors text-sm uppercase tracking-wider"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
